module.exports = __webpack_public_path__ + "static/img/scene_6.90732f3c.png";